import { useNavigate } from 'react-router-dom';
import { FileSignature } from 'lucide-react';
import { Card } from '../ui/Card';
import { WIDGET_HEADER_FLUSH, WidgetCardHeader } from './WidgetCardHeader';
import { Spinner } from '../ui/Spinner';
import { useMyPendingSteps } from '../../hooks/queries/useSignatureCircuits';
import { toSignInbox } from '../../services/signature/circuitRevision';
import { parapheurCircuitPath } from '../../services/signature/parapheurRoutes';
import { WidgetInfiniteList } from './WidgetInfiniteList';
import { revealSlice } from '../../services/dashboard/ordreDuJour';

import { formatAppDate } from '../../lib/dateFormat';
export function ParapheurWidget() {
  const navigate = useNavigate();
  const pending = useMyPendingSteps();

  const steps = toSignInbox(pending.data ?? []).filter((s) => s.circuit);

  return (
    <Card
      className="h-full"
      headerClassName={WIDGET_HEADER_FLUSH}
      header={<WidgetCardHeader icon={FileSignature} title="Parapheur" href="/parapheur" />}
    >
      {pending.isLoading ? (
        <div className="flex justify-center py-4">
          <Spinner />
        </div>
      ) : steps.length === 0 ? (
        <p className="text-sm text-neutral-400 text-center py-3">
          Aucun document à signer
        </p>
      ) : (
        <WidgetInfiniteList itemCount={steps.length}>
          {(visibleCount) => {
            const page = revealSlice(steps, visibleCount);
            return (
              <ul className="space-y-1.5">
                {page.items.map((s) => {
                  const circuit = s.circuit!;
                  const dossierLabel = circuit.dossier
                    ? `${circuit.dossier.title} — ${circuit.dossier.number}`
                    : null;
                  const deadline = s.deadline_at ? new Date(s.deadline_at) : null;
                  const overdue = deadline != null && deadline < new Date();
                  return (
                    <li key={s.id}>
                      <button
                        type="button"
                        onClick={() => navigate(parapheurCircuitPath(circuit.id))}
                        className="w-full flex items-center gap-2 text-left py-1 hover:bg-neutral-50 rounded px-1 transition-colors"
                      >
                        <div className="min-w-0 flex-1">
                          <span className="block text-sm text-neutral-700 truncate">
                            {circuit.title}
                          </span>
                          {dossierLabel && (
                            <span className="block text-[11px] text-neutral-400 truncate">
                              {dossierLabel}
                            </span>
                          )}
                        </div>
                        {deadline && (
                          <span
                            className={`text-xs flex-shrink-0 ${overdue ? 'text-cime-urgent font-medium' : 'text-amber-700'}`}
                          >
                            Éch. {formatAppDate(deadline, { year: false })}
                          </span>
                        )}
                      </button>
                    </li>
                  );
                })}
              </ul>
            );
          }}
        </WidgetInfiniteList>
      )}
    </Card>
  );
}
